(() => {
  if (window.WellfestTheme) return;
  window.WellfestTheme = true;

  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const base = (window.Shopify?.routes?.root || root.dataset.root || '/').replace(/\/?$/, '/');
    const dialog = root.querySelector('[data-cart-dialog]');
    const status = root.querySelector('[data-cart-status]');
    const items = root.querySelector('[data-cart-items]');
    const checkout = root.querySelector('[data-checkout]');
    const conditions = root.querySelector('[data-conditions-dialog]');
    let currency = root.dataset.currency || 'COP';
    let busy = false;
    let opener;
    let lastCart = null;
    checkout.disabled = true;

    const money = value => new Intl.NumberFormat('es-CO', { style: 'currency', currency, maximumFractionDigits: currency === 'COP' ? 0 : 2 }).format(value / 100);
    const el = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };
    async function request(path, body) {
      const response = await fetch(base + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        ...(body ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'No pudimos actualizar el carrito. Inténtalo de nuevo.');
      return data;
    }
    function show(target) {
      opener = document.activeElement;
      if (!target.open) target.showModal();
    }
    function render(cart) {
      lastCart = cart;
      currency = cart.currency || currency;
      root.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
      root.querySelector('[data-cart-total]').textContent = money(cart.total_price);
      checkout.disabled = cart.item_count === 0;
      items.replaceChildren();
      if (!cart.items.length) {
        const empty = el('div', 'wf-empty');
        empty.append(el('h3', '', 'Tu experiencia te espera.'), el('p', '', 'Elige tus entradas y empieza a vivir WellFest.'));
        items.append(empty);
      }
      for (const item of cart.items) {
        const line = el('article', 'wf-cart-line');
        const fallbackImages = {
          'wellfest-2026-clases-especiales': root.dataset.wf26ClassThumb,
          'wellfest-2026-competencia': root.dataset.wf26CompetitionThumb,
          'wellfest-2026-camiseta-oficial': root.dataset.wf26ShirtThumb,
        };
        const imageSource = item.image || fallbackImages[item.handle];
        if (imageSource) {
          const image = el('img', 'wf-cart-thumb');
          image.src = imageSource; image.alt = ''; image.width = 65; image.height = 75;
          line.append(image);
        } else line.append(el('span', 'wf-cart-thumb'));
        const copy = el('div');
        copy.append(el('h3', '', item.product_title || item.title));
        if (item.variant_title && item.variant_title !== 'Default Title') copy.append(el('p', '', item.variant_title));
        for (const [key, value] of Object.entries(item.properties || {})) {
          if (value && !key.startsWith('_')) copy.append(el('p', '', `${key}: ${value}`));
        }
        copy.append(el('p', '', money(item.final_line_price ?? item.line_price)));
        const controls = el('div', 'wf-cart-controls');
        const quantity = el('div', 'wf-quantity');
        const pairOnly = item.handle === 'wellfest-2026-competencia';
        const quantityStep = pairOnly ? 2 : 1;
        const minus = el('button', '', '−');
        minus.type = 'button'; minus.setAttribute('aria-label', pairOnly ? `Quitar una pareja de ${item.product_title}` : `Quitar una entrada de ${item.product_title}`);
        minus.addEventListener('click', () => change(item.key, item.quantity <= quantityStep ? 0 : item.quantity - quantityStep));
        const plus = el('button', '', '+');
        plus.type = 'button'; plus.setAttribute('aria-label', pairOnly ? `Añadir una pareja de ${item.product_title}` : `Añadir una entrada de ${item.product_title}`);
        plus.addEventListener('click', () => change(item.key, item.quantity + quantityStep));
        quantity.append(minus, el('span', '', item.quantity), plus);
        const remove = el('button', 'wf-remove', 'Eliminar');
        remove.type = 'button'; remove.setAttribute('aria-label', `Eliminar ${item.product_title}`);
        remove.addEventListener('click', () => change(item.key, 0));
        controls.append(quantity, remove); copy.append(controls); line.append(copy); items.append(line);
      }
    }
    function setBusy(value) {
      busy = value;
      root.querySelectorAll('[data-ticket-form] button[type="submit"]').forEach(button => {
        if (!button.dataset.soldOut) button.disabled = value;
      });
      items.querySelectorAll('button').forEach(button => button.disabled = value);
      checkout.disabled = value || !lastCart?.item_count;
      dialog.setAttribute('aria-busy', String(value));
    }
    async function refresh() { const cart = await request('cart.js'); render(cart); return cart; }
    async function change(key, quantity) {
      if (busy) return;
      setBusy(true); status.textContent = '';
      try { render(await request('cart/change.js', { id: key, quantity })); }
      catch (error) { status.textContent = error.message || 'Comprueba tu conexión e inténtalo de nuevo.'; }
      finally { setBusy(false); }
    }
    root.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', async () => {
      show(dialog);
      if (busy) return;
      setBusy(true); status.textContent = 'Cargando carrito…';
      try { await refresh(); status.textContent = ''; }
      catch { lastCart = null; status.textContent = 'No pudimos cargar tu carrito. Cierra esta ventana y vuelve a intentarlo.'; }
      finally { setBusy(false); }
    }));
    root.querySelectorAll('dialog').forEach(target => {
      target.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', () => target.close()));
      target.addEventListener('click', event => {
        if (event.target !== target) return;
        const rect = target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) target.close();
      });
      target.addEventListener('close', () => opener?.focus());
    });
    root.querySelector('[data-conditions-open]')?.addEventListener('click', () => show(conditions));

    root.querySelectorAll('[data-ticket-form]').forEach(form => {
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) button.dataset.soldOut = 'true';
      const select = form.querySelector('select[name="id"]');
      const variantInput = form.querySelector('input[name="id"]');
      const ticket = form.closest('.wf-ticket');
      const pairOnly = ticket.hasAttribute('data-pair-ticket');
      const competitionBenefits = new Map();
      const classGoldToggle = form.querySelector('[data-class-gold-toggle]');
      const classGoldFields = form.querySelector('[data-class-gold-fields]');
      const classBenefitInput = form.querySelector('[data-class-benefit-id]');
      const classBenefitValidate = form.querySelector('[data-class-benefit-validate]');
      const classBenefitStatus = form.querySelector('[data-class-benefit-status]');
      const classBenefitShirtChoice = form.querySelector('[data-class-benefit-shirt-choice]');
      const classBenefitShirt = form.querySelector('[data-class-benefit-shirt]');
      let classBenefit;
      const competitionSummary = form.querySelector('[data-competition-summary]');
      const competitionPrice = ticket.querySelector('[data-ticket-price]');
      const competitionPriceLabels = competitionPrice ? [...competitionPrice.querySelectorAll('small')] : [];
      const currentUnitPrice = () => {
        const option = select?.selectedOptions[0] || variantInput;
        const price = Number(option?.dataset.price);
        return Number.isFinite(price) && price >= 0 ? price : null;
      };
      const updateCompetitionTotal = () => {
        if (!pairOnly || !competitionPrice) return;
        const unitPrice = currentUnitPrice();
        if (unitPrice === null) return;
        const benefitCount = competitionBenefits.size;
        const total = Math.max(0, 2 - benefitCount) * unitPrice;
        competitionPrice.replaceChildren(document.createTextNode(money(total)), ...competitionPriceLabels);
        if (competitionSummary) competitionSummary.textContent = benefitCount === 2
          ? 'Los dos competidores tienen beneficio Gold. Total de la pareja: $0.'
          : benefitCount === 1
            ? `Un competidor tiene beneficio Gold. Total de la pareja: ${money(unitPrice)} ${currency}.`
            : `Valor de la pareja: ${money(unitPrice * 2)} ${currency}.`;
      };
      form.querySelectorAll('[data-competitor]').forEach(panel => {
        const position = panel.dataset.competitor;
        const toggle = panel.querySelector('[data-gold-toggle]');
        const fields = panel.querySelector('[data-gold-fields]');
        const input = panel.querySelector('[data-competition-id]');
        const validate = panel.querySelector('[data-competition-validate]');
        const message = panel.querySelector('[data-competition-status]');
        if (!toggle || !fields || !input || !validate || !message) return;
        const reset = () => { competitionBenefits.delete(position); message.textContent = ''; updateCompetitionTotal(); };
        toggle.addEventListener('change', () => {
          fields.hidden = !toggle.checked;
          reset();
          if (toggle.checked) input.focus(); else input.value = '';
        });
        input.addEventListener('input', reset);
        validate.addEventListener('click', async () => {
          const identifier = input.value.trim();
          reset();
          if (!identifier) { message.textContent = 'Ingresa la cédula de este competidor.'; input.focus(); return; }
          validate.disabled = true; message.textContent = 'Consultando beneficio Gold…';
          try {
            const response = await fetch('https://power-club-eight.vercel.app/api/wellfest/competition', {
              method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit',
              body:JSON.stringify({action:'check', identifier})
            });
            const data = await response.json();
            const messages = {
              unavailable:'Esta cédula no aparece en la lista de beneficiarios.',
              redeemed:'Esta cédula ya utilizó su beneficio WellFest.',
              reserved:'Este beneficio ya está reservado en otra compra.',
              setup:'La validación todavía está siendo activada.',
            };
            if (response.ok && data.state === 'available') {
              competitionBenefits.set(position, identifier);
              const unitPrice = currentUnitPrice();
              message.textContent = unitPrice === null
                ? 'Beneficio Gold validado.'
                : `Beneficio Gold validado: descuento de ${money(unitPrice)} ${currency}.`;
              updateCompetitionTotal();
            } else message.textContent = messages[data.state] || data.message || 'No pudimos validar esta cédula.';
          } catch { message.textContent = 'No pudimos conectar con la validación. Inténtalo nuevamente.'; }
          finally { validate.disabled = false; }
        });
      });
      if (classGoldToggle && classGoldFields && classBenefitInput && classBenefitValidate && classBenefitStatus) {
        const resetClassBenefit = () => {
          classBenefit = undefined;
          classBenefitStatus.textContent = '';
          if (classBenefitShirtChoice) classBenefitShirtChoice.hidden = true;
          if (classBenefitShirt) classBenefitShirt.checked = true;
        };
        classGoldToggle.addEventListener('change', () => {
          classGoldFields.hidden = !classGoldToggle.checked;
          resetClassBenefit();
          if (classGoldToggle.checked) classBenefitInput.focus();
          else classBenefitInput.value = '';
        });
        classBenefitInput.addEventListener('input', resetClassBenefit);
        classBenefitValidate.addEventListener('click', async () => {
          const identifier = classBenefitInput.value.trim();
          resetClassBenefit();
          if (!identifier) {
            classBenefitStatus.textContent = 'Ingresa tu cédula para validar el beneficio.';
            classBenefitInput.focus();
            return;
          }
          classBenefitValidate.disabled = true;
          classBenefitStatus.textContent = 'Consultando beneficio Gold…';
          try {
            const response = await fetch('https://power-club-eight.vercel.app/api/wellfest/benefit', {
              method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit',
              body:JSON.stringify({identifier, kind:'class'})
            });
            const data = await response.json();
            const messages = {
              unavailable:'Esta cédula no aparece en la lista de beneficiarios.',
              redeemed:'Esta cédula ya utilizó su beneficio WellFest.',
              reserved:'Este beneficio ya está reservado para otra entrada.',
              review:'Este beneficio necesita una revisión de Power Club.',
              sales_pending:'Las ventas con beneficio todavía no están disponibles.',
              setup:'La validación todavía está siendo activada.',
              rate_limited:'Espera unos minutos antes de volver a intentarlo.',
              invalid:'Revisa el número de cédula e inténtalo de nuevo.',
            };
            if (response.ok && data.state === 'ready' && data.kind === 'class' && data.code && data.variantId) {
              classBenefit = { code:data.code, variantId:String(data.variantId), shirtVariantId:data.shirtVariantId ? String(data.shirtVariantId) : '' };
              classBenefitInput.value = '';
              classBenefitStatus.textContent = 'Beneficio Gold validado: una entrada de clases especiales sin costo.';
              if (classBenefitShirtChoice) classBenefitShirtChoice.hidden = !classBenefit.shirtVariantId;
            } else classBenefitStatus.textContent = messages[data.state] || data.message || 'No pudimos validar esta cédula.';
          } catch { classBenefitStatus.textContent = 'No pudimos conectar con la validación. Inténtalo nuevamente.'; }
          finally { classBenefitValidate.disabled = false; }
        });
      }
      const updatePrice = () => {
        const unitPrice = currentUnitPrice();
        if (unitPrice === null) return;
        const price = ticket.querySelector('[data-ticket-price]');
        const labels = [...price.querySelectorAll('small')];
        const personLabel = price.querySelector('[data-person-price]');
        if (personLabel) personLabel.textContent = `Precio por persona ${money(unitPrice)}`;
        price.replaceChildren(document.createTextNode(money(pairOnly ? unitPrice * 2 : unitPrice)), ...labels);
        updateCompetitionTotal();
      };
      select?.addEventListener('change', updatePrice); updatePrice();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        const feedback = form.querySelector('[data-form-status]');
        const fields = new FormData(form);
        const properties = {};
        for (const [key, value] of fields.entries()) {
          const match = /^properties\[(.+)\]$/.exec(key);
          if (match) properties[match[1]] = value;
        }
        const quantity = Number(fields.get('quantity'));
        if (!Number.isInteger(quantity) || quantity < (pairOnly ? 2 : 1) || quantity > 10 || (pairOnly && quantity % 2 !== 0)) {
          feedback.textContent = pairOnly ? 'La competencia se vende en parejas. Selecciona 2, 4, 6, 8 o 10 entradas.' : 'Selecciona una cantidad válida.';
          return;
        }
        const requestedBenefits = pairOnly ? [...competitionBenefits.values()] : [];
        const checkedGold = pairOnly ? [...form.querySelectorAll('[data-gold-toggle]:checked')].length : 0;
        if (pairOnly && checkedGold !== requestedBenefits.length) {
          feedback.textContent = 'Valida la cédula de cada competidor marcado como Gold Member.';
          return;
        }
        const classGoldChecked = !pairOnly && Boolean(classGoldToggle?.checked);
        if (classGoldChecked && !classBenefit) {
          feedback.textContent = 'Valida tu cédula antes de agregar la entrada con beneficio Gold.';
          return;
        }
        if (classBenefit) {
          if (String(fields.get('id')) !== classBenefit.variantId) {
            classBenefit = undefined;
            feedback.textContent = 'Elige nuevamente tu entrada y vuelve a validar el beneficio Gold.';
            return;
          }
          properties['Beneficio Gold aplicado'] = 'Sí';
          properties['_wf26_benefit_code'] = classBenefit.code;
        }
        if (pairOnly) properties['Beneficios Gold aplicados'] = String(requestedBenefits.length);
        setBusy(true); feedback.textContent = 'Agregando tu entrada…';
        let added = false;
        try {
          let discount;
          if (classBenefit) {
            const cart = await request('cart.js');
            const alreadyAdded = cart.items?.some(item => String(item.variant_id) === classBenefit.variantId && item.properties?._wf26_benefit_code === classBenefit.code);
            discount = classBenefit.code;
            if (alreadyAdded) {
              location.assign('/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent('/cart'));
              return;
            }
          }
          if (requestedBenefits.length) {
            const benefitResponse = await fetch('https://power-club-eight.vercel.app/api/wellfest/competition', {
              method:'POST', headers:{'Content-Type':'application/json'}, credentials:'omit',
              body:JSON.stringify({action:'issue', identifiers:requestedBenefits})
            });
            const benefitData = await benefitResponse.json();
            if (!benefitResponse.ok || benefitData.state !== 'ready') throw new Error(benefitData.message || 'El beneficio ya no está disponible. Vuelve a validar las cédulas.');
            discount = benefitData.code;
          }
          const items = [{ id: Number(fields.get('id')), quantity, properties }];
          if (classBenefit?.shirtVariantId && classBenefitShirt?.checked) items.push({ id: Number(classBenefit.shirtVariantId), quantity:1 });
          await request('cart/add.js', { items });
          added = true;
          feedback.textContent = 'Entrada agregada.';
          if (discount) {
            location.assign('/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent('/cart'));
            return;
          }
          show(dialog); status.textContent = '';
          await refresh();
        } catch (error) {
          if (added) {
            lastCart = null;
            status.textContent = 'Tu entrada se agregó, pero no pudimos actualizar el resumen. Abre de nuevo el carrito antes de continuar.';
          } else feedback.textContent = error.message || 'Comprueba tu conexión e inténtalo de nuevo.';
        } finally { setBusy(false); }
      });
    });
    root.querySelectorAll('[data-method]').forEach(link => link.addEventListener('click', () => {
      const select = root.querySelector('select[name="properties[Clase especial]"]');
      if (!select) return;
      select.value = link.dataset.method === 'Cycling' ? 'Cycling (sujeta a confirmación)' : link.dataset.method;
      setTimeout(() => select.focus({ preventScroll: true }), 100);
    }));
    root.querySelectorAll('[data-ticket-focus]').forEach(link => link.addEventListener('click', () => {
      setTimeout(() => root.querySelector(`.wf-ticket--${link.dataset.ticketFocus} select`)?.focus({ preventScroll: true }), 100);
    }));
  }
  const start = () => document.querySelectorAll('[data-wellfest]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
